<article class="card">
  <!-- pointer-tracked sheen + the 1px gradient edge -->
  <span class="card__sheen" aria-hidden="true"></span>
  <span class="card__edge" aria-hidden="true"></span>

  <!-- upper ~60%: the animated scene -->
  <div class="card__art">
    <app-value-art [id]="item.id"></app-value-art>
    <span class="card__no" aria-hidden="true">{{ item.no }}</span>
    <span class="card__scrim" aria-hidden="true"></span>
  </div>

  <!-- lower: icon, title, copy, arrow -->
  <div class="card__body">
    <span class="card__ico" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 3 5 5.6v5.2c0 4 2.9 7.5 7 8.5 4.1-1 7-4.5 7-8.5V5.6z" />
        <path d="m9.3 11.8 1.9 1.9 3.5-3.7" />
      </svg>
    </span>

    <h3 class="card__title">
      {{ item.title }}
      <span class="card__rule" aria-hidden="true"></span>
    </h3>

    <p class="card__copy">{{ item.copy }}</p>

    <span class="card__arrow" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M7 17 17 7M9 7h8v8" />
      </svg>
    </span>
  </div>
</article>
